import {
    ComponentProps as FormComponentProps
} from '~/frontend/src/components/base/Form';


export default {
    hydrate( inboundState : FormComponentProps & { subPanelProps : any } ) : FormComponentProps {
        const retVal = {
            ...inboundState
        };

        delete retVal.dataStructure;
        delete retVal.dataDescriptors;
        delete retVal.layoutStructure;
        delete retVal.layoutElements;

        delete retVal.subPanelProps;

        delete retVal.onConfigLoad;
        delete retVal.onDataLoad;
        delete retVal.onInvalidData;

        return retVal;
    },

    rehydrate( outboundState : FormComponentProps ) : FormComponentProps {
        return outboundState;
    }
};
